module.exports = __webpack_public_path__ + "static/img/instagram.1344c96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagram.png
// module id = Thay
// module chunks = 0